import type { SortingChapter } from "../sorting/chapters.ts";

/** The ten Magic Workshop chapters (10 levels each); same shape as the Sorting chapters. */
export type FillChapter = SortingChapter;

const chapter = (n: number, themeId: string, name: string, focus: string, palette: readonly [string, string]): FillChapter => ({
  chapter: n,
  themeId,
  name,
  focus,
  firstLevel: (n - 1) * 10 + 1,
  lastLevel: n * 10,
  palette,
});

/** Every chapter adds exactly one idea (docs/MAGIC_WORKSHOP.md §4). */
export const FILL_CHAPTERS: readonly FillChapter[] = [
  chapter(1, "first-silk", "Lụa đầu tay", "Cuộn lăn sang phải và xuống dưới, gặp thành hộp là dừng", ["#fff1f6", "#f3ecff"]),
  chapter(2, "bows", "Nơ thắt sẵn", "Nơ trong hộp chặn lụa lại", ["#ffeef0", "#fff6e2"]),
  chapter(3, "four-ways", "Bốn hướng", "Thêm cuộn lăn sang trái và lên trên", ["#eef6ff", "#f6ecff"]),
  chapter(4, "silk-first", "Lụa trước chặn lụa sau", "Trải đường viền trước cho cột dừng đúng chỗ", ["#f4ecff", "#ffeedd"]),
  chapter(5, "hankies", "Khăn tay", "Cuộn ngắn chỉ trải được vài ô", ["#fff4dc", "#ffe8f0"]),
  chapter(6, "scissors", "Kéo phép", "Lụa chạm kéo là bị cắt ngay tại đó", ["#e6f6f1", "#efe8ff"]),
  chapter(7, "threads", "Chỉ thêu", "Ô thêu chỉ nhận lụa chạy theo đường chỉ", ["#fff0e6", "#eaf3ff"]),
  chapter(8, "scissors-threads", "Kéo gặp chỉ thêu", "Kéo phép và ô thêu chung một hộp", ["#e3f7ff", "#ffe8f2"]),
  chapter(9, "tailor-tricks", "Mẹo thợ may", "Khăn tay, kéo và chỉ thêu cùng một hộp", ["#ffecef", "#eef9ef"]),
  chapter(10, "masterpiece", "Hộp kiệt tác", "Hộp to nhất, thêm cuộn đôi trải cả hai phía", ["#fff0f7", "#e9e6ff"]),
];

export function fillChapterOfLevel(levelId: number): FillChapter {
  const found = FILL_CHAPTERS[Math.floor((levelId - 1) / 10)];
  if (!found) throw new RangeError(`no chapter for level ${levelId}`);
  return found;
}
